var _path, _g, _path2, _path3, _path4, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTenants({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_242_658",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.000488281H41.681V30.0002H0V0.000488281Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_242_658)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8328 27.6825C39.8308 27.7045 39.8298 27.7275 39.8308 27.7485C39.8328 27.8425 39.7978 27.9335 39.7318 27.9995L39.7148 28.0175C39.6458 28.0835 39.5508 28.1205 39.4558 28.1205H27.3708C27.0778 28.1195 26.8018 27.9575 26.6498 27.7005C26.5758 27.5735 26.5368 27.4305 26.5358 27.2865V11.4585C26.5378 11.0005 26.9118 10.6255 27.3668 10.6225H38.9968C39.4548 10.6245 39.8298 10.9995 39.8328 11.4545V27.6825ZM24.6868 11.4545V20.2095H12.4648C12.0998 17.0985 9.4218 14.6975 6.2538 14.6975C5.7898 14.6975 5.3298 14.7485 4.8798 14.8495V3.04249C4.8798 2.69449 5.1638 2.41149 5.5118 2.41149H33.0688C33.4178 2.41149 33.7008 2.69449 33.7008 3.04249V8.77349H27.3618C25.8938 8.78149 24.6928 9.98449 24.6868 11.4545ZM23.6478 27.5575L22.4138 22.6205H24.6868V27.2915C24.6878 27.3805 24.6928 27.4695 24.7018 27.5575H23.6478ZM17.4188 27.5575L18.1938 24.4575H20.3868L21.1618 27.5575H17.4188ZM14.9328 27.5575H10.7638L9.8728 26.0205C11.0218 25.2005 11.8808 23.9825 12.2708 22.6205H16.1668L14.9328 27.5575ZM8.8938 24.4605C8.1258 25.0325 7.2128 25.3335 6.2538 25.3335C3.8178 25.3335 1.8368 23.3625 1.8368 20.9395C1.8368 19.8555 2.2388 18.8135 2.9688 18.0055C3.4408 17.4835 4.0378 17.0765 4.6938 16.8285C5.1938 16.6405 5.7188 16.5445 6.2538 16.5445C7.3588 16.5445 8.4168 16.9545 9.2328 17.6995C10.0448 18.4385 10.5478 19.4415 10.6498 20.5235C10.6638 20.6655 10.6708 20.8055 10.6708 20.9395C10.6708 21.3855 10.6038 21.8255 10.4708 22.2475C10.1958 23.1215 9.6358 23.9085 8.8938 24.4605ZM3.5378 28.1535L4.2848 26.8625C4.9198 27.0745 5.5798 27.1815 6.2538 27.1815C6.9308 27.1815 7.5948 27.0725 8.2318 26.8595L8.9808 28.1535H3.5378ZM41.6818 27.7125V11.4515C41.6748 9.98149 40.4728 8.78149 39.0018 8.77349H36.1118V3.04249C36.1118 1.36549 34.7478 0.000488281 33.0688 0.000488281H5.5118C3.8338 0.000488281 2.4688 1.36549 2.4688 3.04249V15.9745C0.919802 17.1535 -0.000198364 18.9985 -0.000198364 20.9395C-0.000198364 22.9395 1.0068 24.8635 2.6438 26.0275L1.4648 28.0615C1.2098 28.5015 1.1958 28.9825 1.4268 29.3795C1.6548 29.7735 2.0738 30.0005 2.5768 30.0005L8.8248 29.9695H9.9218H9.9418C10.0458 29.9695 10.1478 29.9905 10.2488 29.9695H39.4588C40.6828 29.9695 41.6798 28.9735 41.6818 27.7495V27.7125Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5935 26.1621H32.7755C32.3955 26.1621 32.0855 26.4711 32.0855 26.8511C32.0855 27.2311 32.3955 27.5401 32.7755 27.5401H33.5935C33.9735 27.5401 34.2825 27.2311 34.2825 26.8511C34.2825 26.4711 33.9735 26.1621 33.5935 26.1621Z",
    fill: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2341 3.87939H6.3481V13.2164L6.8131 13.2494C9.8981 13.4684 12.5421 15.4914 13.5491 18.4044L13.6661 18.7414H23.2201V11.4564C23.2291 9.18039 25.0841 7.31739 27.3511 7.30539H32.2341V3.87939Z",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_242_658",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 30
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30H41.681V0H0V30Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_242_658)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.987 25.0388H38.339V12.2598H27.987V25.0388Z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3064 18.3472C5.7794 18.3472 5.2714 18.5062 4.8344 18.8092C4.2814 19.1952 3.8994 19.7782 3.7624 20.4312C3.7054 20.6602 3.6794 20.8562 3.6794 21.0482C3.6794 21.4632 3.7844 21.8602 3.9824 22.2122C4.4464 23.1072 5.3364 23.6622 6.3064 23.6622C7.3104 23.6622 8.2374 23.0652 8.6664 22.1412C8.8324 21.7852 8.9164 21.4022 8.9164 21.0052C8.9164 20.8622 8.9054 20.7142 8.8814 20.5672C8.6734 19.2812 7.5904 18.3472 6.3064 18.3472Z",
    fill: "transparent"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenants);
export default __webpack_public_path__ + "static/media/tenants.f220c8a3276224452c0903e7214df79e.svg";
export { ForwardRef as ReactComponent };